export const TRANSLATIONS_TEMP = {
  it: {
    "La razza inserita non è tra quelle ammesse dal PMS":
      "La razza inserita non è tra quelle ammesse dal PMS",
    "Ultima modifica il [lastUpdated]": "Ultima modifica il {{lastUpdated}}",
    'I contatti mostrati sono quelli che rispettano i criteri della lista "[listName]"':
      'I contatti mostrati sono quelli che rispettano i criteri della lista "{{listName}}"',
    "Il PMS sta cercando fra tutti i tuoi contatti, l|operazione potrebbe richiedere tempo.":
      "Il PMS sta cercando fra tutti i tuoi contatti, l'operazione potrebbe richiedere tempo.",
    "I risultati mostrati sono una parte dell|elenco completo utilizzato durante l|esecuzione della campagna":
      "I risultati mostrati sono una parte dell'elenco completo utilizzato durante l'esecuzione della campagna",
    "Se però preferisci non riceverle più, puoi annullare l|iscrizione cliccando sul pulsante qui sotto.":
      "Se però preferisci non riceverle più, puoi annullare l'iscrizione cliccando sul pulsante qui sotto.",
    "Fattura [number] del [date]": "Fattura {{number}} del {{date}}",
    "Fattura [number] bozza": "Fattura {{number}} bozza",
    "ed altre [count]": "ed altre {{count}}",
    "ed altri [count]": "ed altri {{count}}",
    "variable-firstName": "Nome",
    "variable-lastName": "Cognome",
    "variable-email": "Email",
    "variable-phone": "Telefono",
    "variable-businessName": "Ragione sociale",
    "variable-ssn": "Codice fiscale",
    "variable-vatNumber": "Partita IVA",
    "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell|agenda":
      "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell'agenda",
    "IVA obbligatoria": "IVA obbligatoria",
    "Prezzo non valorizzato": "Prezzo non valorizzato",
    "Messo in conto": "Messo in conto",
    "Aggiungi un farmaco da modifica ricetta":
      "Aggiungi un farmaco da modifica ricetta",
    "Stampa fatture": "Stampa fatture",
    "La dimensione del documento è oltre i limiti di stampa":
      "La dimensione del documento è oltre i limiti di stampa",
    "Non è possibile stampare più di [limit] fatture":
      "Non è possibile stampare più di {{limit}} fatture",
    "Operazione in corso: [progress]%": "Operazione in corso: {{progress}}%",
    "Invia fatture": "Invia fatture",
    "Invio fatture in corso": "Invio fatture in corso",
    "Stampa [count] fatture di [name]": "Stampa {{count}} fatture di {{name}}",
    "Non è possibile stampare più di [limit] giorni di appuntamenti":
      "Non è possibile stampare più di {{limit}} giorni di appuntamenti",
    Ora: "Ora",
    Riconfezionamento: "Riconfezionamento",
    Riconfezionato: "Riconfezionato",
    "Arrotondamento commerciale": "Arrotondamento commerciale",
    "Arrotondamento commerciale impostato in fattura":
      "Arrotondamento commerciale impostato in fattura",
    "Impossibile impostare l'arrotondamento commerciale in fattura":
      "Impossibile impostare l'arrotondamento commerciale in fattura",
    "Arrotondamento commerciale disabilitato in fattura":
      "Arrotondamento commerciale disabilitato in fattura",
    "Impossibile disabilitare l'arrotondamento commerciale in fattura":
      "Impossibile disabilitare l'arrotondamento commerciale in fattura",
    "Piano dei conti": "Piano dei conti",
    "Codice Ditta": "Codice Ditta",
    "Conto Cliente (ricavi)": "Conto Cliente (ricavi)",
    "Conto Fornitore (costi)": "Conto Fornitore (costi)",
    "IVA Vendita": "IVA Vendita",
    "Conto con Ritenuta d'acconto": "Conto con Ritenuta d'acconto",
    "Conto senza Ritenuta d'acconto": "Conto senza Ritenuta d'acconto",
    "Conto esente IVA": "Conto esente IVA",
    "Conto predefinito": "Conto predefinito",
    "Conto prestazioni veterinarie - IVA 22%":
      "Conto prestazioni veterinarie - IVA 22%",
    "Conto cessione farmaci - IVA 10%": "Conto cessione farmaci - IVA 10%",
    "Conto articoli vari/prodotti - IVA 4%":
      "Conto articoli vari/prodotti - IVA 4%",
    "Cassa contanti": "Cassa contanti",
    Banca: "Banca",
    "Codici IVA": "Codici IVA",
    "Conti ricavo netto (imponibili)": "Conti ricavo netto (imponibili)",
    "Conti patrimoniali": "Conti patrimoniali",
    Qualifica: "Qualifica",
    "member-medical": "Medico",
    "member-administrative": "Amministrativo",
    Assistente: "Assistente",
    "Eseguito da fatturare": "Eseguito da fatturare",
    "Eseguito totale": "Eseguito totale",
    "Aggiunta l|azione condividi nel dettaglio della ricetta":
      "Aggiunta l'azione condividi nel dettaglio della ricetta",
    "Corretto un problema che in alcuni casi impediva l|aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento":
      "Corretto un problema che in alcuni casi impediva l'aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento",
    "Corretto un problema che impediva di navigare alla data odierna nell|agenda":
      "Corretto un problema che impediva di navigare alla data odierna nell'agenda",
    "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?":
      "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?",
    "Per procedere, specificare il sesso":
      "Per procedere, specificare il sesso",
    "Inserito da": "Inserito da",
    Quantita: "Quantità",
    "Quantità da aggiungere": "Quantità da aggiungere",
    "Quantità attuale": "Quantità attuale",
    "Nuova quantità": "Nuova quantità",
    "Corretto un problema nell|esportazione dei pazienti":
      "Corretto un problema nell'esportazione dei pazienti",
    "Sono presenti delle notule importate":
      "Sono presenti delle notule importate",
    "Notula esistente": "Notula esistente",
    "Esiste già una notula per questo cliente.":
      "Esiste già una notula per questo cliente.",
    "Trovata una notula sul cliente": "Trovata una notula sul cliente",
    "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.":
      "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.",
    Apri: "Apri",
    "Crea nuova fattura": "Crea nuova fattura",
    Annulla: "Annulla",
    "Primo semestre": "Primo semestre",
    "Secondo semestre": "Secondo semestre",
    Allega: "Allega",
    "Inserito il [date]": "Inserito il {{date}}",
    "Esporta le righe di fattura per metodo di pagamento selezionate in Excel":
      "Esporta le righe di fattura per metodo di pagamento selezionate in Excel",
    "Visualizza condizioni d|uso del modulo API":
      "Visualizza condizioni d'uso del modulo API",
    "Accetto le condizioni d|uso": "Accetto le condizioni d'uso",
    "E| necessario visulizzare le condizioni d|uso per procedere":
      "E' necessario visulizzare le condizioni d'uso per procedere",
    "Caricato [loaded] di [total]": "Caricato {{loaded}} di {{total}}",
    "Impossibile creare l|ordine": "Impossibile creare l'ordine",
    "Ordine #[number]": "Ordine #{{number}}",
    "Periodo compreso tra il [from] ed il [to]":
      "Periodo compreso tra il {{from}} ed il {{to}}",
    "Impossibile aggiungere l'acconto selezionato":
      "Impossibile aggiungere l'acconto selezionato",
    "Impossibile caricare i dati di utilizzo":
      "Impossibile caricare i dati di utilizzo",
    "Impossibile caricare l'API key": "Impossibile caricare l'API key",
    Integrazione: "Integrazione",
    "Copiato negli appunti": "Copiato negli appunti",
    Copia: "Copia",
    "Metodo 1: Header x-api-key": "Metodo 1: Header x-api-key",
    "Metodo 2: Parametro query apiKey": "Metodo 2: Parametro query apiKey",
    "Installazione: parametro query apiKey":
      "Installazione: parametro query apiKey",
    "URL di connessione": "URL di connessione",
    "URL MCP da copiare": "URL MCP da copiare",
    "Copia URL MCP": "Copia URL MCP",
    "Attivazione dell'integrazione in corso":
      "Attivazione dell'integrazione in corso. L'URL sarà disponibile a breve.",
    "Collegare un MCP custom a Claude": "Collegare un MCP custom a Claude",
    "Apri Claude e seleziona Personalizza nella barra laterale":
      "Apri Claude e seleziona Personalizza nella barra laterale",
    "Seleziona Connettori nella barra laterale":
      "Seleziona Connettori nella barra laterale",
    "Fai clic sul pulsante + per aggiungere un connettore":
      "Fai clic sul pulsante + per aggiungere un connettore",
    "Seleziona Aggiungi connettore personalizzato":
      "Seleziona Aggiungi connettore personalizzato",
    "Inserisci un nome, incolla l'URL MCP nel campo URL del server remoto e fai clic su Aggiungi":
      "Inserisci un nome, incolla l'URL MCP nel campo URL del server remoto e fai clic su Aggiungi",
    "⚠️ Disclaimer Legale, Privacy e AI Act":
      "⚠️ Disclaimer Legale, Privacy e AI Act",
    "Protezione dei dati, responsabilità e conformità normativa":
      "Protezione dei dati, responsabilità e conformità normativa",
    "L'utilizzo del Snoots Connector for AI implica il trasferimento di dati gestionali verso piattaforme di intelligenza artificiale di terze parti.":
      "L'utilizzo del Snoots Connector for AI implica il trasferimento di dati gestionali, inclusi dati relativi a clienti, pazienti animali e informazioni commerciali, verso piattaforme di intelligenza artificiale di terze parti (Anthropic, OpenAI, Google e altri provider AI).",
    "📋 Conformità GDPR (Reg. UE 2016/679)":
      "📋 Conformità GDPR (Reg. UE 2016/679)",
    "L'utente è responsabile di:": "L'utente è responsabile di:",
    "Garantire che il trattamento dei dati tramite piattaforme AI di terze parti sia conforme al GDPR e a qualsiasi altra normativa applicabile in materia di protezione dei dati personali.":
      "Garantire che il trattamento dei dati tramite piattaforme AI di terze parti sia conforme al Regolamento UE 2016/679 (GDPR) e a qualsiasi altra normativa applicabile in materia di protezione dei dati personali.",
    "Verificare le policy di privacy e i termini di servizio del provider AI prescelto prima di trasferire qualsiasi dato.":
      "Verificare le policy di privacy e i termini di servizio del provider AI prescelto prima di trasferire qualsiasi dato.",
    "Non trasferire dati sensibili di pazienti o clienti verso ambienti AI non conformi alle normative vigenti.":
      "Non trasferire dati sensibili di pazienti o clienti verso ambienti AI non conformi alle normative vigenti.",
    "Ottenere, ove necessario, il consenso informato dei propri clienti al trattamento dei loro dati tramite strumenti AI e informarli in modo chiaro di tale utilizzo.":
      "Ottenere, ove necessario, il consenso informato dei propri clienti al trattamento dei loro dati tramite strumenti AI e informarli in modo chiaro di tale utilizzo.",
    "Proteggere adeguatamente le proprie credenziali di accesso e non condividerle con terze parti.":
      "Proteggere adeguatamente le proprie credenziali di accesso e non condividerle con terze parti.",
    "🤖 Conformità AI Act (Reg. UE 2024/1689)":
      "🤖 Conformità AI Act (Reg. UE 2024/1689)",
    "Il Regolamento UE sull'Intelligenza Artificiale introduce ulteriori obblighi per chi utilizza sistemi AI. L'utente è responsabile di:":
      "Il Regolamento UE sull'Intelligenza Artificiale (AI Act), in vigore dall'agosto 2024 con applicazione progressiva, introduce ulteriori obblighi per chi utilizza sistemi AI. L'utente è responsabile di:",
    "Trasparenza verso i propri clienti: se i dati di clienti o pazienti vengono elaborati tramite sistemi AI, i soggetti interessati devono essere informati in modo chiaro e comprensibile dell'utilizzo di tecnologie di intelligenza artificiale. Non è sufficiente inserire un riferimento nei soli termini e condizioni.":
      "Trasparenza verso i propri clienti (Art. 50, applicabile da agosto 2026): se i dati di clienti o pazienti vengono elaborati tramite sistemi AI, i soggetti interessati devono essere informati in modo chiaro e comprensibile dell'utilizzo di tecnologie di intelligenza artificiale. Non è sufficiente inserire un riferimento nei soli termini e condizioni.",
    "Supervisione umana: i risultati e le analisi generate dall'AI devono essere sempre rivisti e validati da personale qualificato prima di essere utilizzati per prendere decisioni che incidano su clienti, pazienti o sull'attività clinica. L'AI è uno strumento di supporto, non un sostituto del giudizio professionale.":
      "Supervisione umana: i risultati e le analisi generate dall'AI devono essere sempre rivisti e validati da personale qualificato prima di essere utilizzati per prendere decisioni che incidano su clienti, pazienti o sull'attività clinica. L'AI è uno strumento di supporto, non un sostituto del giudizio professionale.",
    "Verifica del provider AI: i modelli AI di uso generale quali Claude, ChatGPT e Gemini sono soggetti agli obblighi previsti dall'AI Act per i loro rispettivi fornitori a partire da agosto 2025. L'utente è tenuto a verificare che il provider AI scelto sia conforme a tali obblighi.":
      "Verifica del provider AI: i modelli AI di uso generale (GPAI) quali Claude, ChatGPT e Gemini sono soggetti agli obblighi previsti dall'AI Act per i loro rispettivi fornitori (Anthropic, OpenAI, Google) a partire da agosto 2025. L'utente è tenuto a verificare che il provider AI scelto sia conforme a tali obblighi.",
    "Alfabetizzazione AI: le organizzazioni che impiegano sistemi AI devono assicurare che il personale coinvolto disponga di un adeguato livello di comprensione delle tecnologie AI utilizzate, dei loro limiti e dei rischi connessi.":
      "Alfabetizzazione AI (Art. 4, applicabile da febbraio 2025): le organizzazioni che impiegano sistemi AI devono assicurare che il personale coinvolto disponga di un adeguato livello di comprensione delle tecnologie AI utilizzate, dei loro limiti e dei rischi connessi.",
    "Classificazione del rischio: il Snoots Connector for AI è un connettore dati per sistemi di gestione veterinaria e non è classificato come sistema AI ad alto rischio ai sensi dell'Allegato III del AI Act. Tuttavia, l'utente rimane responsabile della modalità con cui utilizza i dati e le analisi generate.":
      "Classificazione del rischio: il Snoots Connector for AI è un connettore dati per sistemi di gestione veterinaria e non è classificato come sistema AI ad alto rischio ai sensi dell'Allegato III del AI Act. Tuttavia, l'utente rimane responsabile della modalità con cui utilizza i dati e le analisi generate.",
    "ℹ️ Nota: la normativa AI Act è in fase di applicazione progressiva. Si raccomanda di consultare un consulente legale per una valutazione completa della propria posizione di conformità.":
      "ℹ️ Nota: la normativa AI Act è in fase di applicazione progressiva. Si raccomanda di consultare un consulente legale per una valutazione completa della propria posizione di conformità, in particolare in relazione agli obblighi che entreranno pienamente in vigore ad agosto 2026.",
    "Snoots declina ogni responsabilità per eventuali danni, perdite o violazioni derivanti da un utilizzo improprio del plugin, dalla mancata osservanza del GDPR o del AI Act, da decisioni prese sulla base di output AI non validati da personale qualificato, o da configurazioni non sicure da parte dell'utente. Il plugin viene fornito così com'è a titolo gratuito, senza garanzie di alcun tipo.":
      "Snoots declina ogni responsabilità per eventuali danni, perdite o violazioni derivanti da un utilizzo improprio del plugin, dalla mancata osservanza del GDPR o del AI Act, da decisioni prese sulla base di output AI non validati da personale qualificato, o da configurazioni non sicure da parte dell'utente. Il plugin viene fornito \"così com'è\" a titolo gratuito, senza garanzie di alcun tipo.",
    "Per informazioni sulla privacy di Snoots:":
      "Per informazioni sulla privacy di Snoots:",
    "URL MCP": "URL MCP",
    "API Key": "API Key",
    "Esempio URL completo": "Esempio URL completo",
    "Header da impostare: x-api-key": "Header da impostare: x-api-key",
    "Intro integrazione MCP":
      "Collega Snoots MCP copiando l'URL con parametro apiKey negli strumenti supportati.",
    "Intro metodo header":
      "Usa questa modalità se il tuo strumento supporta l'impostazione di header HTTP personalizzati.",
    "Nota metodo header":
      "L'API key viene inviata nell'header x-api-key ad ogni richiesta. Più sicuro perché la chiave non appare nell'URL.",
    "Intro metodo query":
      "Usa questa modalità se il tuo strumento accetta solo un URL e non permette di configurare header aggiuntivi.",
    "Nota metodo query": "Non condividere l'URL: contiene la chiave API.",
    "Hai utilizzato un acconto incassato con un profilo fiscale differente.":
      "Hai utilizzato un acconto incassato con un profilo fiscale differente.",
    "L'acconto presenta i seguenti parziali già assegnati:":
      "L'acconto presenta i seguenti parziali già assegnati:",
    "L'acconto è già assegnato in una notula:":
      "L'acconto è già assegnato in una notula:",
    "Performance economica": "Performance economica",
    "Clienti e pazienti": "Clienti e pazienti",
    "Efficienza operativa": "Efficienza operativa",
    "Qualità e soddisfazione": "Qualità e soddisfazione",
    "Ticket medio": "Ticket medio",
    "Fatturato medio per contatto": "Fatturato medio per contatto",
    "Fatturato medio per paziente": "Fatturato medio per paziente",
    "Pazienti entrati in clinica": "Pazienti entrati in clinica",
    "Tasso di crescita contatti": "Tasso di crescita contatti",
    "Prestazioni per paziente": "Prestazioni per paziente",
    "Tempo di attesa medio": "Tempo di attesa medio",
    "Tempo di permanenza medio": "Tempo di permanenza medio",
    "Soddisfazione clienti": "Soddisfazione clienti",
    "Più opzioni": "Più opzioni",
    "Valore medio delle fatture": "Valore medio delle fatture",
    "Importo medio fatturato per contatto":
      "Importo medio fatturato per contatto",
    "Importo medio fatturato da ciascun veterinario":
      "Importo medio fatturato da ciascun veterinario",
    "Importo medio fatturato per ogni paziente":
      "Importo medio fatturato per ogni paziente",
    "Numero di pazienti entrati in clinica nel periodo":
      "Numero di pazienti entrati in clinica nel periodo",
    "Rapporto tra numero di pretazione e numero di pazienti":
      "Rapporto tra numero di pretazione e numero di pazienti",
    "Media durata in minuti, eccetto i pazienti in degenza":
      "Media durata in minuti, eccetto i pazienti in degenza",
    "Media della soddisfazione cliente nel periodo":
      "Media della soddisfazione cliente nel periodo",
    "L|interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.":
      "L'interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.",
    "L|interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.":
      "L'interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.",
    "Il servizio sta subendo un|interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.":
      "Il servizio sta subendo un'interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.",
    "L|interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.":
      "L'interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.",
    "Il servizio sta subendo un|interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.":
      "Il servizio sta subendo un'interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.",
    "[number] del [emittedAt]": "{{number}} del {{emittedAt}}",
    e: "e",
    giorno: "giorno",
    giorni: "giorni",
    mese: "mese",
    mesi: "mesi",
    anno: "anno",
    anni: "anni",
    "Totale: [value]": "Totale: {{value}}",
    "Fatture insolute: [value]": "Fatture insolute: {{value}}",
    "Clienti insoluti al [date]": "Clienti insoluti al {{date}}",
    "Totale fatturato: [value]": "Totale fatturato: {{value}}",
    "Totale incassato: [value]": "Totale incassato: {{value}}",
    "Totale insoluto: [value]": "Totale insoluto: {{value}}",
    "Fatture insolute di [nominative] al [date]":
      "Fatture insolute di {{nominative}} al {{date}}",
    "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?":
      "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?",
    "Non è possibile emettere una fattura senza il nome del cliente":
      "Non è possibile emettere una fattura senza il nome del cliente",
    "Ordine n° [orderNumber] inserito con successo!":
      "Ordine n° {{orderNumber}} inserito con successo!",
    "Completa l|acquisto": "Completa l'acquisto",
    'Cliccando su "Completa l|acquisto" accetti l|ordine e ti impegni a pagare l|importo indicato.':
      "Cliccando su \"Completa l'acquisto\" accetti l'ordine e ti impegni a pagare l'importo indicato.",
    "[name] importato": "{{name}} importato",
    "study-in-acquisition": "In acquisizione",
    "IVA [value]": "IVA {{value}}",
    "Abilita per continuare": "Abilita per continuare",
    "Seleziona un provider per compilare i campi":
      "Seleziona un provider per compilare i campi",
    "Il paziente ha un acconto non ancora consumato":
      "Il paziente ha un acconto non ancora consumato",
    "È stato trovato un acconto di [remainingAmount] non ancora utilizzato.":
      "È stato trovato un pagamento anticipato di {{remainingAmount}} non ancora utilizzato.",
    "Non mostrare più": "Non mostrare più",
    "Crediti per invio email esauriti": "Crediti per invio email esauriti",
    Autorizzazioni: "Autorizzazioni",
    "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.":
      "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.",
    Gratuito: "Gratuito",
    "Cerca per nome o descrizione…": "Cerca per nome o descrizione…",
    Criterio: "Criterio",
    Destinatario: "Destinatario",
    "changelog.advanced.title": "Cosa c'è di nuovo",
    "changelog.advanced.subtitle.v143":
      "Agenda rinnovata, ruoli, fatturazione guidata e nuovi connettori",
    "changelog.advanced.brand.pms": "Snoots PMS",
    "changelog.advanced.helpCenter": "Help Center →",
    "changelog.advanced.footer.v143": "Aprile 2026 · Snoots PMS",
    "changelog.advanced.stat.agenda": "Novità agenda",
    "changelog.advanced.stat.users": "Utenti & ruoli",
    "changelog.advanced.stat.connectors": "Connettori",
    "changelog.advanced.stat.ux": "Usabilità",
    "changelog.advanced.stat.invoicing": "Fatturazione",
    "changelog.advanced.tab.agenda": "Agenda",
    "changelog.advanced.tab.users": "Utenti",
    "changelog.advanced.tab.billing": "Fatturazione",
    "changelog.advanced.tab.ux": "Usabilità",
    "changelog.advanced.tab.connectors": "Connettori",
    "changelog.advanced.tab.ai": "AI",
    "changelog.advanced.stat.ai": "AI",
    "changelog.advanced.ai.snt10001":
      "Introduzione MCP all'interno del Marketplace di Snoots",
    "changelog.advanced.section.agenda": "Agenda e scheduler",
    "changelog.advanced.section.users": "Gestione utenti e ruoli",
    "changelog.advanced.section.billing": "Fatturazione e contabilità",
    "changelog.advanced.section.ux": "Miglioramenti di usabilità",
    "changelog.advanced.section.connectors": "Nuovi connettori e integrazioni",
    "changelog.advanced.agenda.snt10025":
      "Divisione dello scheduler per reparti: ogni reparto ha la propria vista",
    "changelog.advanced.agenda.snt10023":
      "Gli appuntamenti mostrano il colore del medico assegnato",
    "changelog.advanced.agenda.snt10022":
      "Nome e cognome del medico per intero negli appuntamenti",
    "changelog.advanced.agenda.snt10026":
      "Indicazione di chi è in turno direttamente in agenda",
    "changelog.advanced.agenda.snt10168":
      "Ricerca e filtro degli appuntamenti per reparto",
    "changelog.advanced.agenda.snt10170":
      "Filtro scheduler per risorse prenotabili e reparti",
    "changelog.advanced.users.snt10162":
      "Nuova interfaccia per modifica di utenti, ruoli e autorizzazioni",
    "changelog.advanced.users.snt10165":
      "Ogni profilo utente include ora ruolo, colore e reparto di appartenenza",
    "changelog.advanced.users.snt10166":
      "Tag reparto per categorizzare rapidamente lo staff",
    "changelog.advanced.users.snt10167":
      "Colonna reparto aggiunta nella lista utenti",
    "changelog.advanced.users.snt10169":
      "Colonna che indica se l'utente è configurato come prenotabile",
    "changelog.advanced.billing.snt9826":
      "Emissione guidata delle fatture: flusso step-by-step fino all'invio",
    "changelog.advanced.billing.snt10124":
      "Alert automatico sui preventivi non aggiornati dopo modifiche al tariffario",
    "changelog.advanced.billing.snt10242":
      "Gestione notule direttamente sul profilo cliente",
    "changelog.advanced.ux.snt9966":
      "PIN di accesso: caratteri nascosti durante la digitazione",
    "changelog.advanced.ux.snt10014":
      '"Seleziona tutto" nel diario clinico per operazioni rapide',
    "changelog.advanced.ux.snt10020":
      "Link diretto all'Help Center accessibile dal PMS",
    "changelog.advanced.ux.snt10108":
      "Conferma esplicita prima di eliminare una cartella clinica",
    "changelog.advanced.ux.snt9294":
      'Campo "eseguito da" selezionabile direttamente dal preventivo',
    "changelog.advanced.ux.snt10033":
      "Grado di soddisfazione cliente visibile nell'anagrafica contatto",
    "changelog.advanced.ux.snt10200":
      "Consegna studi diagnostici al proprietario direttamente dal PMS",
    "changelog.advanced.connector.snt8828": "SNT-8828 · Commercialista",
    "changelog.advanced.connector.snt9726": "SNT-9726 · Laboratorio",
    "changelog.advanced.connector.snt9720": "SNT-9720 · Analizzatore",
    "changelog.advanced.connector.snt9389": "SNT-9389 · Antibiotici",
    "changelog.advanced.connector.snt10224": "SNT-10224 · Biochimico",
    "changelog.advanced.connector.snt10225": "SNT-10225 · Elettroforesi",
    "changelog.advanced.connector.snt10226": "SNT-10226 · Coagulativo",
    "changelog.advanced.connector.snt10227": "SNT-10227 · Ormonali",
    "changelog.advanced.subtitle.v14336":
      "Acconti, notule numerate, assegna a dal preventivo e nuove scorciatoie",
    "changelog.advanced.footer.v14336": "Maggio 2026 · Snoots PMS",
    "changelog.advanced.stat.newFeatures": "Nuove funzioni",
    "changelog.advanced.stat.improvements": "Migliorie",
    "changelog.advanced.stat.fixesRelease": "Correzioni",
    "changelog.advanced.tab.video": "▶ Video",
    "changelog.advanced.tab.fixes": "Correzioni",
    "changelog.advanced.tabCount.new": "NEW",
    "changelog.advanced.v14336.video.heading": "📹 Video della release",
    "changelog.advanced.v14336.video.caption":
      "Guarda le novità di questa release",
    "changelog.advanced.v14336.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14336.video.inThisVideo": "In questo video",
    "changelog.advanced.v14336.video.bullet.1":
      "Panoramica delle novità principali della release v1.43.37",
    "changelog.advanced.v14336.video.bullet.2":
      "Demo delle funzionalità più richieste",
    "changelog.advanced.v14336.video.bullet.3":
      "Consigli d'uso e best practice",
    "changelog.advanced.v14336.ux.1":
      "Ripristino visualizzazione acconti da scheda cliente",
    "changelog.advanced.v14336.ux.2":
      "Colore tag statistiche fatturato ora resta fisso per una maggiore facilità d'uso",
    "changelog.advanced.v14336.billing.1":
      'Possibilità di selezionare l\'"Assegna a" direttamente dal preventivo',
    "changelog.advanced.v14336.billing.2":
      "Le notule sono ora numerate per un'identificazione più semplice",
    "changelog.advanced.v14336.billing.3":
      "Possibilità di inviare una mail direttamente dal gestionale cliccando sull'indirizzo email del cliente",
    "changelog.advanced.v14336.fixes.section": "Correzioni minori",
    "changelog.advanced.v14336.fixes.summary":
      "correzioni minori applicate in questa release per una maggiore stabilità e affidabilità del gestionale.",
    "changelog.advanced.subtitle.v14342":
      "Novità sulla stampa documenti — guarda il video per i dettagli",
    "changelog.advanced.footer.v14342": "Maggio 2026 · Snoots PMS",
    "changelog.advanced.stat.printRelease": "Stampa",
    "changelog.advanced.tab.print": "Stampa",
    "changelog.advanced.v14342.video.heading": "📹 Video della release",
    "changelog.advanced.v14342.video.caption":
      "Guarda le novità di questa release",
    "changelog.advanced.v14342.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14342.video.detailsHeading": "In questa release",
    "changelog.advanced.v14342.print.1":
      "Rimosso il limite di stampa dei documenti",
    "changelog.advanced.subtitle.v14346":
      "Agenda e scheduler rinnovati — guarda il video per i dettagli",
    "changelog.advanced.footer.v14346": "Maggio 2026 · Snoots PMS",
    "changelog.advanced.v14346.video.heading": "📹 Video della release",
    "changelog.advanced.v14346.video.caption":
      "Guarda le novità di Snoots v1.43.46",
    "changelog.advanced.v14346.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14346.video.detailsHeading": "In questa release",
    "changelog.advanced.v14346.agenda.1":
      "Nuova vista elenco per consultare gli appuntamenti con filtro per periodo",
    "changelog.advanced.v14346.agenda.2":
      "Toolbar unificata con viste Scheduler, Agenda ed Elenco e switch giornaliero/settimanale",
    "changelog.advanced.v14346.agenda.3":
      "Selettore di periodo nel pannello laterale quando usi la vista elenco",
    "changelog.advanced.subtitle.v14375":
      "Aree con PIN, onboarding staff e miglioramenti agenda — guarda il video per i dettagli",
    "changelog.advanced.footer.v14375": "Giugno 2026 · Snoots PMS",
    "changelog.advanced.v14375.video.heading": "📹 Video della release",
    "changelog.advanced.v14375.video.caption":
      "Guarda le novità di Snoots v1.43.75",
    "changelog.advanced.v14375.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14375.video.detailsHeading": "In questa release",
    "changelog.advanced.v14375.item.1": "Aggiunte le Aree con PIN",
    "changelog.advanced.v14375.item.2":
      "Aggiunto l'onboarding per i membri dello staff",
    "changelog.advanced.v14375.item.3": "Corretti alcuni problemi in Agenda",
    "changelog.advanced.v14375.item.4": "Correzioni minori",
    "changelog.advanced.subtitle.v144":
      "Tab verticali, squadratura fattura, Wolters Kluwer e miglioramenti agenda e clinica",
    "changelog.advanced.footer.v144": "Luglio 2026 · Snoots PMS",
    "changelog.advanced.stat.clinica": "Clinica",
    "changelog.advanced.tab.clinica": "Clinica",
    "changelog.advanced.tab.contacts": "Contatti",
    "changelog.advanced.tab.inventory": "Magazzino",
    "changelog.advanced.section.clinica": "Clinica e ricoveri",
    "changelog.advanced.section.contacts": "Contatti e marketing",
    "changelog.advanced.section.inventory": "Magazzino",
    "changelog.advanced.v144.fixes.section": "Correzioni minori",
    "changelog.advanced.v144.fixes.summary":
      "correzioni minori applicate in questa release per una maggiore stabilità e affidabilità del gestionale.",
    "changelog.advanced.v144.ux.1":
      "Introdotte le tab verticali nelle pagine di dettaglio, con suggerimento di orientamento",
    "changelog.advanced.v144.ux.2":
      "Aggiunte azioni compatte nella toolbar delle pagine di dettaglio",
    "changelog.advanced.v144.ux.3":
      "Migliorato il componente PIN per le aree protette",
    "changelog.advanced.v144.ux.4":
      "Aggiunta conferma di salvataggio nei componenti modificabili inline",
    "changelog.advanced.v144.ux.5":
      "Migliorato il popup con gestione z-index per evitare sovrapposizioni",
    "changelog.advanced.v144.ux.6":
      "Migliorata la gestione ticket con ordinamento e data ultimo aggiornamento",
    "changelog.advanced.v144.ux.7":
      "Aggiornate le notifiche nella user bar e il dettaglio fattura",
    "changelog.advanced.v144.ux.8":
      "Corretto il redirect nella pagina di modifica paziente",
    "changelog.advanced.v144.agenda.1":
      "Aggiunto il tipo di turno presso altra struttura",
    "changelog.advanced.v144.agenda.2":
      "Aggiunto avviso quando si crea un appuntamento non assegnato",
    "changelog.advanced.v144.agenda.3":
      "Migliorato il reload delle colonne in agenda ed esclusi gli appuntamenti annullati",
    "changelog.advanced.v144.agenda.4":
      "Disabilitata l'apertura automatica del sidespace al check-in",
    "changelog.advanced.v144.users.1":
      "Rinnovata la pagina di modifica ruolo con nuove abilitazioni per campaign, segmentation e quota",
    "changelog.advanced.v144.users.2":
      "Aggiunta gestione permesso per le ricerche avanzate",
    "changelog.advanced.v144.billing.1":
      "Introdotto il calcolo della squadratura in fattura, inclusa IVA e ENPAV",
    "changelog.advanced.v144.billing.2":
      "Allineata la pagina di edit tariffario al tema v2",
    "changelog.advanced.v144.billing.3":
      "Gestito default IVA per tenant svizzero",
    "changelog.advanced.v144.billing.4":
      "Migliorata la gestione degli eventi su profilo fiscale e sezionale",
    "changelog.advanced.v144.clinica.1":
      "Rifattorizzata e corretta la pagina di modifica vaccino",
    "changelog.advanced.v144.clinica.2":
      "Gestita l'anamnesi lunga nel dettaglio ricovero",
    "changelog.advanced.v144.clinica.3":
      "Aggiunto stato di caricamento nell'aggiunta farmaco su ricetta",
    "changelog.advanced.v144.clinica.4":
      "Aggiunto warning per template scheda SOAP vuota",
    "changelog.advanced.v144.contacts.1":
      "Aggiunto filtro residenza contatto per nazione e regioni IT/CH in segmentation",
    "changelog.advanced.v144.contacts.2":
      "Gestito il cambio proprietario su paziente",
    "changelog.advanced.v144.inventory.1": "Migliorata la tabella movimenti",
    "changelog.advanced.v144.inventory.2":
      "Corretto il confronto inventario con magazzino",
    "changelog.advanced.v144.inventory.3": "Gestita la disabilitazione storage",
    "changelog.advanced.v144.connectors.1":
      "Aggiunta esportazione verso gestionale esterno Wolters Kluwer",
    "changelog.advanced.subtitle.v146":
      "Ricerca globale, medici esterni, consegna digitale e miglioramenti agenda, clinica e fatturazione",
    "changelog.advanced.footer.v146": "Settembre 2026 · Snoots PMS",
    "changelog.advanced.stat.configuration": "Configurazione",
    "changelog.advanced.tab.configuration": "Configurazione",
    "changelog.advanced.section.configuration": "Configurazione e abbonamenti",
    "changelog.advanced.v146.fixes.section": "Correzioni minori",
    "changelog.advanced.v146.fixes.summary":
      "correzioni minori applicate in questa release per una maggiore stabilità e affidabilità del gestionale.",
    "changelog.advanced.v146.ux.1":
      "Ricerca globale ottimizzata con proprietari cliccabili e ricerca avanzata",
    "changelog.advanced.v146.ux.2":
      "Medici esterni spostati in Gestione utenti con inserimento e-mail semplificato",
    "changelog.advanced.v146.ux.3":
      "Rinnovate le sezioni configurazione stanze, conti correnti e metodi di pagamento",
    "changelog.advanced.v146.ux.4":
      "Migliorata la visibilità della colonna modello promemoria su schermi laptop",
    "changelog.advanced.v146.ux.5":
      "Rimosso il filtro predefinito sulla tab promemoria nel dettaglio cliente",
    "changelog.advanced.v146.agenda.1":
      "Granularità dello scheduler configurabile (es. quarti d'ora)",
    "changelog.advanced.v146.agenda.2":
      "Note appuntamento visibili nel ticket della dashboard",
    "changelog.advanced.v146.agenda.3":
      "Durata appuntamento preservata in modifica",
    "changelog.advanced.v146.agenda.4":
      "Check-in da altre sezioni allinea correttamente ticket e appuntamento",
    "changelog.advanced.v146.agenda.5":
      "Motivo di presentazione mantiene la colonna staff",
    "changelog.advanced.v146.billing.1":
      "Anteprima del prossimo numero fattura in fase di emissione",
    "changelog.advanced.v146.billing.2":
      "Aggiornamento in tempo reale della sezione conti aperti",
    "changelog.advanced.v146.billing.3":
      "Riveduta la definizione del modello preventivo",
    "changelog.advanced.v146.billing.4":
      "Corretto il vincolo sul campo «Eseguito da» nei template preventivo",
    "changelog.advanced.v146.clinica.1":
      "Aggiunta la data di primo ingresso/check-in in scheda clinica (vista e stampa)",
    "changelog.advanced.v146.clinica.2":
      "Consegna digitale referti diagnostica e schede cliniche al proprietario",
    "changelog.advanced.v146.clinica.3":
      "Allineata la modal di creazione medico curante",
    "changelog.advanced.v146.users.1":
      "Attivazione e disattivazione PIN senza obbligo di cambiare il codice",
    "changelog.advanced.v146.users.2":
      "Utenti eliminati esclusi dalle utenze per l'accesso con PIN",
    "changelog.advanced.v146.configuration.1":
      "Completata la sezione configurazione piani digitali e abbonamenti",
    "changelog.advanced.v146.configuration.2":
      "Abilitazione consegna digitale dalla configurazione diagnostica",
    "Ricerca globale ottimizzata con proprietari cliccabili e ricerca avanzata":
      "Ricerca globale ottimizzata con proprietari cliccabili e ricerca avanzata",
    "Medici esterni in Gestione utenti, piani digitali e consegna digitale referti":
      "Medici esterni in Gestione utenti, piani digitali e consegna digitale referti",
    "Miglioramenti agenda: granularità scheduler, note appuntamento, durata in modifica":
      "Miglioramenti agenda: granularità scheduler, note appuntamento, durata in modifica",
    "Data di check-in in scheda clinica e miglioramenti fatturazione e preventivi":
      "Data di check-in in scheda clinica e miglioramenti fatturazione e preventivi",
    "Rinnovata la gestione degli appuntamenti in agenda con apertura del form nel pannello laterale (Sidespace)":
      "Rinnovata la gestione degli appuntamenti in agenda con apertura del form nel pannello laterale (Sidespace)",
    "Aggiunto avviso nel form appuntamento quando data e ora di inizio sono nel passato":
      "Aggiunto avviso nel form appuntamento quando data e ora di inizio sono nel passato",
    "Migliorata la selezione del paziente con etichetta compatta (nome, specie ed età)":
      "Migliorata la selezione del paziente con etichetta compatta (nome, specie ed età)",
    "Migliorata la dashboard statistiche con scrolling virtuale e nuove strutture dati":
      "Migliorata la dashboard statistiche con scrolling virtuale e nuove strutture dati",
    "Migliorate le anteprime PDF dei documenti con caricamento lazy e cache di sessione":
      "Migliorate le anteprime PDF dei documenti con caricamento lazy e cache di sessione",
    "Migliorata la selezione degli orari di fine appuntamento con opzioni a step di 15 minuti e indicazione della durata":
      "Migliorata la selezione degli orari di fine appuntamento con opzioni a step di 15 minuti e indicazione della durata",
    "Aggiunto zoom e regolazione larghezza barre nei grafici delle statistiche":
      "Aggiunto zoom e regolazione larghezza barre nei grafici delle statistiche",
    "Migliorata la validazione delle date in agenda":
      "Migliorata la validazione delle date in agenda",
    "Migliorata la gestione dell'indirizzo in anagrafica clienti con validazione al cambio":
      "Migliorata la gestione dell'indirizzo in anagrafica clienti con validazione al cambio",
    "Aggiunte informazioni tooltip nello scheduler":
      "Aggiunte informazioni tooltip nello scheduler",
    "Correzioni minori": "Correzioni minori",
    "member-technical": "Tecnico",
    "Totale insoluto": "Totale insoluto",
    "Stampa riepilogo": "Stampa riepilogo",
    "Visualizza risultato": "Visualizza risultato",
    "Sei sicuro di voler eliminare [count] notule?":
      "Sei sicuro di voler eliminare {{count}} notule?",
    "Elimina notule": "Elimina notule",
    "Bozza n. [number]": "Bozza n. {{number}}",
    "Check In rapido": "Check In rapido",
    "Check-in e inizia visita": "Check-in e inizia visita",
    "Scegliere cosa includere nella stampa:":
      "Scegliere cosa includere nella stampa:",
    "Tutte le voci (fatturate e da fatturare)":
      "Tutte le voci (fatturate e da fatturare)",
    "Solo voci da fatturare": "Solo voci da fatturare",
    "Solo voci già fatturate": "Solo voci già fatturate",
    "Settimana [weekNumber]": "Settimana {{weekNumber}}",
    "Presso altra struttura": "Presso altra struttura",
    Specializzazioni: "Specializzazioni",
    "Qualifica e specializzazioni": "Qualifica e specializzazioni",
    "Abbiamo tutto ciò che ci serve. Stiamo preparando il tuo spazio di lavoro!":
      "Abbiamo tutto ciò che ci serve. Stiamo preparando il tuo spazio di lavoro!",
    "Accetta appuntamenti": "Accetta appuntamenti",
    "Non accetta appuntamenti": "Non accetta appuntamenti",
    "Aggiunta la gestione delle specializzazioni dello staff":
      "Aggiunta la gestione delle specializzazioni dello staff",
    "Migliorati i filtri dell'agenda per qualifica, reparto e specializzazione":
      "Migliorati i filtri dell'agenda per qualifica, reparto e specializzazione",
    "Migliorata la selezione dello staff nella creazione degli appuntamenti con indicazione di turni e reparti":
      "Migliorata la selezione dello staff nella creazione degli appuntamenti con indicazione di turni e reparti",
    "I turni possono essere configurati e visualizzati per reparto":
      "I turni possono essere configurati e visualizzati per reparto",
    "Convertito da lead": "Convertito da lead",
    "Modifica cliente": "Modifica cliente",
    "Modifica i dati del cliente.": "Modifica i dati del cliente.",
    "Modifica paziente": "Modifica paziente",
    "Modifica i dati del paziente.": "Modifica i dati del paziente.",
    "Modifica impostazioni": "Modifica impostazioni",
    "Modifica lingua, zona, studi e backup del tenant.":
      "Modifica lingua, zona, studi e backup del tenant.",
    "Schede verticali": "Schede verticali",
    "Schede orizzontali": "Schede orizzontali",
    "Per navigare più facilmente tra le schede, attiva la visualizzazione verticale":
      "Per navigare più facilmente tra le schede, attiva la visualizzazione verticale",
    "Attiva le schede verticali e le azioni compatte: libera spazio su schermi piccoli con schede laterali colorate e barra azioni scorrevole":
      "Attiva le schede verticali e le azioni compatte: libera spazio su schermi piccoli con schede laterali colorate e barra azioni scorrevole",
    "Attiva le schede verticali e le azioni compatte (solo icone): libera spazio su schermi piccoli e rende ogni scheda riconoscibile dal colore dell'icona":
      "Attiva le schede verticali e le azioni compatte (solo icone): libera spazio su schermi piccoli e rende ogni scheda riconoscibile dal colore dell'icona",
    "Attiva schede verticali": "Attiva schede verticali",
    "Disattiva schede verticali": "Disattiva schede verticali",
    Preferenze: "Preferenze",
    Interfaccia: "Interfaccia",
    "Usa schede verticali colorate e azioni compatte nelle pagine di dettaglio con più di due schede.":
      "Usa schede verticali colorate e azioni compatte nelle pagine di dettaglio con più di due schede.",
    "Stai usando la nuova visualizzazione con schede verticali colorate e barra azioni per gruppo":
      "Stai usando la nuova visualizzazione con schede verticali colorate e barra azioni per gruppo",
    "Attiva le azioni compatte (solo icone): libera spazio e rende ogni gruppo di azioni riconoscibile dal colore":
      "Attiva le azioni compatte (solo icone): libera spazio e rende ogni gruppo di azioni riconoscibile dal colore",
    "Stai usando le azioni compatte con icone colorate per gruppo":
      "Stai usando le azioni compatte con icone colorate per gruppo",
    "Attiva azioni compatte": "Attiva azioni compatte",
    "Disattiva azioni compatte": "Disattiva azioni compatte",
    "Azioni compatte": "Azioni compatte",
    "Usa azioni compatte (solo icone) con colori per gruppo nella barra azioni delle pagine di dettaglio.":
      "Usa azioni compatte (solo icone) con colori per gruppo nella barra azioni delle pagine di dettaglio.",
    "Ripristina versione precedente": "Ripristina versione precedente",
    "Staff non compilato": "Staff non compilato",
    "Vuoi continuare comunque con la creazione dell'appuntamento?":
      "Vuoi continuare comunque con la creazione dell'appuntamento?",
    "Hai selezionato {{selectedCount}} allegati. Il massimo consentito è {{maxCount}}. Riduci la selezione per procedere.":
      "Hai selezionato {{selectedCount}} allegati. Il massimo consentito è {{maxCount}}. Riduci la selezione per procedere.",
    "Le prestazioni nelle notule esistenti verranno unificate in un unica notula. Continuare?":
      "Le prestazioni nelle notule esistenti verranno unificate in un unica notula. Continuare?",
    "Modifica modello comunicazione": "Modifica modello comunicazione",
    "Modifica modello promemoria": "Modifica modello promemoria",
    "Modifica il contenuto del modello usato nelle comunicazioni.":
      "Modifica il contenuto del modello usato nelle comunicazioni.",
    "Modifica il contenuto del modello usato per i promemoria ai clienti.":
      "Modifica il contenuto del modello usato per i promemoria ai clienti.",
    Profis: "Profis",
    "Codice piano dei conti": "Codice piano dei conti",
    "Numero attività IVA": "Numero attività IVA",
    "Numero registro IVA vendite": "Numero registro IVA vendite",
    "Codice IVA — 22%": "Codice IVA — 22%",
    "Codice IVA — 10%": "Codice IVA — 10%",
    "Codice IVA — 4%": "Codice IVA — 4%",
    "Codice IVA — esente": "Codice IVA — esente",
    "Causale — fattura vendita / acconto":
      "Causale — fattura vendita / acconto",
    "Causale — nota credito": "Causale — nota credito",
    "Causale — nota debito": "Causale — nota debito",
    "Causale — fattura acquisto": "Causale — fattura acquisto",
    "Causale — incasso / prima nota": "Causale — incasso / prima nota",
    "Conto ausiliario fattura (importo zero)":
      "Conto ausiliario fattura (importo zero)",
    "Conto ausiliario incasso": "Conto ausiliario incasso",
    "Conto chiusura partita incasso": "Conto chiusura partita incasso",
    "Gestione partite clienti": "Gestione partite clienti",
    "Cliente privato (default)": "Cliente privato (default)",
    Auto: "Auto",
    Sempre: "Sempre",
    Mai: "Mai",
    "Pianificato il": "Pianificato il",
    "Data primo check-in": "Data primo check-in"
  },
  en: {
    "Corretto un problema che impediva l'aggiornamento automatico dei documenti di un paziente dopo la creazione":
      "Fixed an issue that prevented a patient's documents from automatically updating after creation",
    "Corretto un problema che in alcuni casi impediva di selezionare gli allegati da inviare di un paziente":
      "Fixed an issue that in some cases prevented selecting a patient's attachments to send",
    "Hai selezionato {{selectedCount}} allegati. Il massimo consentito è {{maxCount}}. Riduci la selezione per procedere.":
      "You selected {{selectedCount}} attachments. The maximum allowed is {{maxCount}}. Reduce the selection to proceed.",
    "Corretto un problema che impediva la corretta visualizzazione dei membri in turno nello scheduler":
      "Fixed an issue that prevented the correct display of on-duty members in the scheduler",
    "Settimana [weekNumber]": "Week {{weekNumber}}",
    Bozza: "Draft",
    "Bozza n. [number]": "Draft n. {{number}}",
    "member-technical": "Technical",
    "member-administrative": "Administrative",
    "member-medical": "Medical",
    "IVA [value]": "VAT {{value}}",
    "study-in-acquisition": "In acquisition",
    "[name] importato": "{{name}} imported",
    "Codice fiscale non coerente con i dati anagrafici inseriti":
      "The fiscal code doesn't match the information provided",
    "Ci sono delle prestazioni da fatturare":
      "There are medical services to be billed",
    "Menziona in un task": "Tag on a task",
    "Non ci sono fatture insolute": "There aren't any overdue invoices",
    Pagina: "Page",
    "Totale fatturato": "Total billed",
    "Clienti insoluti": "Overdue customers",
    "Ci sono delle fatture insolute": "There is at least one overdue invoice",
    Insoluto: "Outstanding",
    "Fatture insolute": "Overdue invoices",
    "Tel.": "Phone",
    "Scaduta il": "Expired on",
    "Fatture insolute di [nominative] al [date]":
      "Overdue invoices of {{nominative}} as of {{date}}",
    "Clienti insoluti al [date]": "Overdue customers as of {{date}}",
    "Totale fatturato: [value]": "Total billed: {{value}}",
    "Totale incassato: [value]": "Total collected: {{value}}",
    "Totale insoluto: [value]": "Total outstanding: {{value}}",
    "Fatture insolute: [value]": "Overdue invoices: {{value}}",
    "Totale: [value]": "Total: {{value}}",
    "Tool utilizzati": "Tools used",
    "[number] del [emittedAt]": "{{number}} of {{emittedAt}}",
    "Cerca per nome...": "Search by name...",
    "Cerca per nome o descrizione…": "Search by name or description…",
    Criterio: "Criterion",
    Destinatario: "Target",
    "Inserimento ordine in corso...": "Order insertion in progress...",
    "Vai i miei ordini": "Go to my orders",
    "Dati fatturazione": "Billing data",
    "Email di fatturazione": "Billing email",
    "Verrai automaticamente reindirizzato alla pagina dei miei ordini in 5 secondi...":
      "You will be automatically redirected to my orders page in 5 seconds...",
    'Cliccando su "Completa l|acquisto" accetti l|ordine e ti impegni a pagare l|importo indicato.':
      'By clicking on "Complete purchase" you accept the order and undertake to pay the amount indicated.',
    "Polo di erogazione": "Delivery point",
    Creati: "Created",
    "Vai al servizio": "Go to service",
    "Dati estratti dallo studio": "Data extracted from the study",
    "Fee transazione": "Transaction fee",
    "Transazione #": "Transaction #",
    "Effettuata il": "Made on",
    "Parzialmente completato": "Partially completed",
    Consegnato: "Delivered",
    "In attesa": "In progress",
    "In coda": "In queue",
    "Upload in corso": "Uploading in progress",
    Caricato: "Loaded",
    Errore: "Error",
    Rimuovi: "Remove",
    "I miei ordini": "My orders",
    "In Lavorazione": "In progress",
    Completato: "Done",
    Assegnato: "Assigned",
    "Il carrello è vuoto": "The cart is empty",
    "Aggiungi dei servizi per iniziare": "Add services to start",
    "Completa l|acquisto": "Complete the purchase",
    "Aggiungi al carrello": "Add to cart",
    Diagnostico: "Diagnostic",
    Catalogo: "Catalog",
    Spese: "Expenses",
    Completati: "Done",
    "Ricevi qui i tuoi referti": "Receive your reports here",
    "Cerca negli ordini...": "Search in orders...",
    "Medico refertatore": "Referral doctor",
    "Scegli il medico refertatore": "Choose the referral doctor",
    Carrello: "Cart",
    "Aggiungi altri servizi": "Add more services",
    "Corretto un problema nella geatione dei turni":
      "Fixed a problem in shifts manager",
    "Ordine n° [orderNumber] inserito con successo!":
      "Order n° {{orderNumber}} inserted successfully!",
    "Non hai sufficiente spazio disponibile nel disco": "Disk space is low",
    "Migliorata la gestione del pin e lo sblocco della sessione":
      +"Better pin management and session unlock",
    "Migliorati i tab, ora sono sempre tutti visibili":
      "Tabs are now always visible",
    "Corretto un problema nelle statistiche con gli importi in negativo":
      "Fixed a problem with negative amounts in statistics",
    "Aggiunta possibilità di retrodatare i vaccini":
      "Added the possibility to go back in time for vaccines",
    "Corretto un problema nella pagina di dettaglio delle fatture passive":
      "Fixed a problem in the passive invoice details page",
    "Migliorate le performance in export fatture":
      "Improved performance in invoice exports",
    "Il servizio è pienamente operativo. Tutte le funzionalità sono disponibili.":
      "The service is fully operational. All features are available.",
    "Clicca per visualizzare maggiori dettagli": "Click to view more details",
    "L|interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.":
      "The outage has been fully resolved. The service is now fully operational. Thank you for your patience.",
    "L|interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.":
      "The partial outage has been resolved. The service is now fully operational. Thank you for your patience.",
    "Il servizio sta subendo un|interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.":
      "The service is currently undergoing a partial outage. Some features may be temporarily unavailable. We are working to restore full operational capacity.",
    "L|interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.":
      "The primary outage has been partially resolved. Some features remain temporarily unavailable. We are continuing to work to restore full operational capacity.",
    "Il servizio sta subendo un|interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.":
      "The service is currently undergoing a significant outage. Some or all features may be unavailable. We are working to resolve the issue as soon as possible.",
    "Corretto un problema relativo alla flowboard":
      "Fixed an issue related to the flowboard",
    "Corretto un problema nella visualizzazione delle checklist nelle schede SOAP":
      "Fixed a problem with the display of checklists in the SOAP cards",
    "Aggiunti i KPI": "Added KPI",
    "Aggiunta la possibilità di creare un collegamento ad un contato o ad un paziente in un task":
      "Added the possibility to create a link to a contact or a patient in a task",
    "Aggiunta la possibilità di stampare massivamente le fatture":
      "Added the possibility to print invoices in bulk",
    "Aggiunta la possibilità di filtrare gli elementi presenti nella flowboard":
      "Added the possibility to filter elements present in the flowboard",
    "Migliorata la visiilità delle ferie in agenda":
      "Improved the visibility of holidays in agenda",
    "Aggiunta la possibilità di cercare i contatti tramite numero identificativo":
      "Added the possibility to search contacts by identification number",
    "Corretti alcuni problemi relativi ai ricoveri":
      "Fixed some issues related to recoveries",
    "Apportati alcuni miglioramenti alle statistiche":
      "Added some improvements to statistics",
    "Corretti alcuni problemi nella visualizzazione dei turni in agenda":
      "Fixed some issues with the display of shifts in agenda",
    "Periodo compreso tra il [from] ed il [to]":
      "Period between {{from}} and {{to}}",
    "Attendere il completamento della stampa prima di chiudere la pagina":
      "Please wait for printing to complete before closing the page.",
    "E| necessario visulizzare le condizioni d|uso per procedere":
      "Required to view terms of use to proceed",
    "Accetto le condizioni d|uso": "Accept terms of use",
    "Visualizza condizioni d|uso del modulo API": "View API terms of use",
    "Corretto un problema che in alcuni casi impediva di inviare e stampare i documenti allegati al paziente":
      "Fixed a problem that in some cases prevented sending and printing attached documents to a patient",
    "Ora la stampa degli appuntamenti in agenda è allineata ai filtri in uso":
      "Appointments printing in agenda is now aligned with the filters in use",
    "Inserito il [date]": "Added on {{date}}",
    "Ordine #[number]": "Order #{{number}}",
    "Corretto un problema nell|esportazione dei pazienti":
      "Fixed a problem with the export of patients",
    "Impossibile creare l|ordine": "Unable to create the order",
    "Caricato [loaded] di [total]": "Loaded {{loaded}} of {{total}}",
    Quantita: "Quantity",
    "Quantità da aggiungere": "Quantity to add",
    "Quantità attuale": "Current quantity",
    "Nuova quantità": "New quantity",
    "Fatturato totale": "Total sales",
    "Nuovi clienti": "New customers",
    "Per specie": "By species",
    Staff: "Staff",
    "Per aliquota": "By VAT rate",
    "Per centro di ricavo": "By revenue centre",
    "Per metodo di pagamento": "By payment method",
    Giorni: "Days",
    "Confronto per anni": "Comparison per years",
    "Nuovi pazienti per specie": "New patients by species",
    "Check-in per specie": "Check-in by species",
    "Seleziona anni": "Select years",
    "Corretti alcuni problemi nelle statistiche":
      "Fixed some issues in statistics",
    "Aggiunti i filtri nella sezione dei promemoria inseriti":
      "Added filters in the inserted reminders section",
    "Aggiunto il dettaglio di una scheda clinica di tipo laboratorio":
      "Added details of a laboratory clinical card",
    "Revisione delle statistiche": "Statistics review",
    "Aggiunta la possibilità di confrontare nello statistiche lo stesso periodo su più anni":
      "Added the possibility to compare the same period in more years in the statistics",
    "Nello scheduler ora è possibile attivare la visualizzazione solo per turni dello staff":
      "From the scheduler it is possible to activate the display only for staff shifts",
    "Aggiunto il codice cliente nel file di esportazione":
      "Added the customer code in the export file",
    "Rimossi i conti paziente datati sul conto di cassa aperto":
      "Removed patient accounts that are linked to the open cash account",
    "Aggiunto un avviso nel caso in cui un paziente abbia una razza non prevista in Snoots PMS":
      "Added warning in case a patient has a breed not provided in Snoots PMS",
    "La razza inserita non è tra quelle ammesse dal PMS":
      "The breed entered is not among those allowed by the PMS",
    "Aggiunto un avviso nel caso in cui la razza di un paziente non sia tra quelle previste in Snoots PMS":
      "Added warning in case a patient's breed is not among the ones provided in Snoots PMS",
    "Nella versione mobile non è possibile selezionare più di due mmebri dello staff":
      "Nella versione mobile non è possibile selezionare più di due membri dello staff",
    "Corretto un problema che in alcuni casi mostrava orari errati negli appuntamenti della flowboard":
      "Fixed a problem that in some cases showed wrong times on appointments in flowboard",
    "Corretto un problema che posizionava in maniera errata il popup per la creazione di un nuovo appuntamento":
      "Fixed a problem that positioned incorrectly the popup for creating a new appointment",
    "Corretto un problema che impediva di navigare alla data odierna nell|agenda":
      "Fixed a problem that prevented navigating to today's date in the agenda",
    "Corretto un problema che impediva la visualizzazione delle note nei ticket":
      "Fixed a problem that prevented note display in tickets",
    "Nuovo aggiornamento": "New update",
    "Snoots PMS è stato aggiornato! Per non perderti le ultime novità e miglioramenti ricarica ora il PMS!":
      "Snoots PMS has been updated! Don't miss the latest news and improvements! Reload the PMS now!",
    "Rocket è stato aggiornato! Per non perderti le ultime novità e miglioramenti ricarica ora!":
      "Rocket has been updated! Don't miss the latest news and improvements! Reload now!",
    "Aggiunta l|azione condividi nel dettaglio della ricetta":
      "Added share action in recipe details",
    "Aggiunto il filtro per motivo di scarico nei movimenti di uno storage":
      "Added download reason filter in one storage movement",
    "Aggiunta la data di nascita nella modifica di un contatto":
      "Added birth date in contact modification",
    "Aggiunta la possibilità di non visualizzare i nomi del personale non medico che ha effettuato le prestazioni":
      "Added option to hide non medical staff names",
    "Ora sono visibili con maggior evidenza gli appuntamenti annullati nella dashboard e nella flowboard":
      "Appointments cancelled are now more visible on the dashboard and flowboard",
    'Aggiunto lo stato "Fatturato" nel preventivo':
      "Added status 'Billed' in the quote",
    "Aggiunta la stampa degli appuntamenti in agenda":
      "Added appointments printing in agenda",
    "Corretto un problema che in alcuni casi impediva il caricamento del prezzo di un farmaco inserito tramite scansione":
      "Fixed a problem that in some cases prevented the loading of a drug price inserted by scan",
    "Corretto un problema che in alcuni casi impediva l|aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento":
      "Fixed a problem that in some cases prevented the update of a quote after changing the maximum price of an element",
    "Includi ricevuta di pagamento": "Include payment receipt",
    "Ricevuta di pagamento": "Payment receipt",
    "Metodo di pagamento": "Payment method",
    Data: "Date",
    "Importo incassato": "Amount collected",
    "Seleziona il tenant con cui accedere": "Select the tenant to access",
    oppure: "or",
    "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell|agenda":
      "Fixed a problem that in some cases prevented a correct positioning of the agenda",
    "Corretto un problema nel calcolo delle statistiche delle campagne":
      "Fixed a problem with the calculation of campaign statistics",
    "Comunicazioni - Modifica campagna": "Campaigns - Edit campaign",
    "Clicca qui": "Click here",
    "per non ricevere più queste email": "to not receive these emails anymore",
    Consegnate: "Delivered",
    "Sottoscrizioni annullate": "Subscriptions cancelled",
    "Non consegnate": "Not delivered",
    "In errore": "In error",
    Lette: "Read",
    "Insoluto da 30 giorni": "Unpaid for 30 days",
    "Insoluto da 60 giorni": "Unpaid for 60 days",
    "Insoluto da 90 giorni": "Unpaid for 90 days",
    "Insoluto da 120 giorni": "Unpaid for 120 days",
    "Paziente di almeno (anni)": "Patient at least (years)",
    "Clienti con un cane": "Customers with a dog",
    "Clienti con un gatto": "Customers with a cat",
    Personalizzato: "Custom",
    "variable-firstName": "Firstnam",
    "variable-lastName": "Lastname",
    "variable-email": "Email",
    "variable-phone": "Phone",
    "variable-businessName": "Business name",
    "variable-ssn": "Fiscal code",
    "variable-vatNumber": "Tax number",
    "ed altre [count]": "and other {{count}}",
    "ed altri [count]": "and other {{count}}",
    "Fattura [number] bozza": "Invoice {{number}} draft",
    "Fattura [number] del [date]": "Invoice {{number}} of {{date}}",
    "Ci dispiace vederti andare": "Sorry to see you go",
    "Siamo spiacenti che tu stia pensando di annullare l'iscrizione.":
      "Sorry we are sorry that you are thinking of unsubscribing",
    "Le nostre comunicazioni sono pensate per aiutarti a prenderti cura al meglio della salute del tuo animale.":
      "Our communications are designed to help you take care of your pet's health.",
    "Se però preferisci non riceverle più, puoi annullare l|iscrizione cliccando sul pulsante qui sotto.":
      "If you still prefer not to receive them anymore, you can unsubscribe by clicking the button below.",
    "Ultima modifica il [lastUpdated]": "Last updated on {{lastUpdated}}",
    'I contatti mostrati sono quelli che rispettano i criteri della lista "[listName]"':
      'Contacts shown are those that meet the criteria of the list "[listName]"',
    "Pianifica almeno una campagna": "Schedule at least one campaign",
    "Il PMS sta cercando fra tutti i tuoi contatti, l|operazione potrebbe richiedere tempo.":
      "The PMS is searching among all your contacts, the operation may take time.",
    "I risultati mostrati sono una parte dell|elenco completo utilizzato durante l|esecuzione della campagna":
      "The results shown are a part of the complete list used during the campaign",
    "IVA obbligatoria": "VAT required",
    "Prezzo non valorizzato": "Price required",
    "Messo in conto": "Added to book",
    "Aggiungi un farmaco da modifica ricetta":
      "Add a medicine in edit prescription",
    "Stampa fatture": "Print invoices",
    "La dimensione del documento è oltre i limiti di stampa":
      "The document size exceeds the print limits",
    "La data e l'orario di inizio sono nel passato":
      "The start date and time are in the past",
    "Non è possibile stampare più di [limit] fatture":
      "It is not possible to print more than {{limit}} invoices",
    "Operazione in corso: [progress]%": "Operation in progress: {{progress}}%",
    "Invia fatture": "Send invoices",
    "Invio fatture in corso": "Sending invoices in progress",
    "Stampa [count] fatture di [name]":
      "Printing {{count}} invoices of {{name}}",
    "Aggiunte le statistiche per metodo di pagamento":
      "Added payment statistics",
    "Aggiunta la possibilità di aggiungere al conto paziente dalla ricetta":
      "Added possibility to add patient to book from prescription",
    "Aggiunta la possibilità di stampare massivamente le fatture di un cliente":
      "Added possibility to print invoices of a customer",
    "Agginuta la categoria nell'estrazione di prestazioni":
      "Added category in extraction of services",
    "Ora l'agenda mostra gli appuntamenti in formato tabellare":
      "Now the agenda shows appointments in tabular format",
    "Aggiunta la possibilità di stampare la ricevuta degli incassi di una fattura":
      "Added possibility to print the receipt of an invoice",
    "Aggiunta la possibilità di inviare la ricevuta degli incassi di una fattura via email":
      "Added possibility to send the receipt of an invoice via email",
    "Ora i tab dei clienti/pazienti mostrano il titolo più chiaramente":
      "Now the tabs of customers/patients show the title more clearly",
    "Nella vista risorse dell'agenda vengono mostrati di default lo staff in turno":
      "In the agenda resources view, the staff in turn is shown by default",
    "Non è possibile stampare più di [limit] giorni di appuntamenti":
      "It is not possible to print more than {{limit}} days of appointments",
    Ora: "Time",
    Riconfezionamento: "Packaging",
    Riconfezionato: "Repackaged",
    "Arrotondamento commerciale": "Commercial rounding",
    "Arrotondamento commerciale impostato in fattura":
      "Commercial rounding enabled in invoice",
    "Impossibile impostare l'arrotondamento commerciale in fattura":
      "It is not possible enable commercial rounding in invoice",
    "Arrotondamento commerciale disabilitato in fattura":
      "Commercial rounding disabled in invoice",
    "Impossibile disabilitare l'arrotondamento commerciale in fattura":
      "It is not possible disable commercial rounding in invoice",
    "Piano dei conti": "Chart of accounts",
    "Codice Ditta": "Company Code",
    "Conto Cliente (ricavi)": "Customer Account (Revenue)",
    "Conto Fornitore (costi)": "Supplier Account (Costs)",
    "IVA Vendita": "Sales VAT",
    "Conto con Ritenuta d'acconto": "Account with Withholding Tax",
    "Conto senza Ritenuta d'acconto": "Account without Withholding Tax",
    "Conto esente IVA": "VAT-exempt Account",
    "Conto predefinito": "Default Account",
    "Conto prestazioni veterinarie - IVA 22%":
      "Veterinary Services Account - 22% VAT",
    "Conto cessione farmaci - IVA 10%": "Drug Sales Account - 10% VAT",
    "Conto articoli vari/prodotti - IVA 4%":
      "Various Items/Products Account - 4% VAT",
    "Cassa contanti": "Cash Register",
    Banca: "Bank",
    "Codici IVA": "VAT Codes",
    "Conti ricavo netto (imponibili)": "Net Revenue Accounts (Taxable)",
    "Conti patrimoniali": "Balance Sheet Accounts",
    Qualifica: "Qualification",
    Assistente: "Assistant",
    "Eseguito da fatturare": "Executed to invoice",
    "Eseguito totale": "Executed total",
    "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?":
      "The phone and/or email configured for the appointment differ from those in the customer record. Do you want to update them?",
    "Per procedere, specificare il sesso":
      "In order to proceed, specify the patient sex",
    "Inserito da": "Added by",
    "Sono presenti delle notule importate": "There are imported draft invoices",
    "Primo semestre": "First semi-annual",
    "Secondo semestre": "Second semi-annual",
    Allega: "Attach",
    "Esporta le righe di fattura per metodo di pagamento selezionate in Excel":
      "Export selected payment method invoice lines to Excel",
    "Impossibile aggiungere l'acconto selezionato":
      "Cannot add the selected deposit",
    "Impossibile caricare i dati di utilizzo": "Unable to load usage data",
    "Impossibile caricare l'API key": "Unable to load API key",
    Integrazione: "Integration",
    "Copiato negli appunti": "Copied to clipboard",
    Copia: "Copy",
    "Metodo 1: Header x-api-key": "Method 1: Header x-api-key",
    "Metodo 2: Parametro query apiKey": "Method 2: Query param apiKey",
    "Installazione: parametro query apiKey":
      "Installation: apiKey query parameter",
    "URL di connessione": "Connection URL",
    "URL MCP da copiare": "MCP URL to copy",
    "Copia URL MCP": "Copy MCP URL",
    "Attivazione dell'integrazione in corso":
      "Integration activation in progress. The URL will be available shortly.",
    "Collegare un MCP custom a Claude": "Connect a custom MCP to Claude",
    "Apri Claude e seleziona Personalizza nella barra laterale":
      "Open Claude and select Customize in the sidebar",
    "Seleziona Connettori nella barra laterale":
      "Select Connectors in the sidebar",
    "Fai clic sul pulsante + per aggiungere un connettore":
      "Click the + button to add a connector",
    "Seleziona Aggiungi connettore personalizzato":
      "Select Add custom connector",
    "Inserisci un nome, incolla l'URL MCP nel campo URL del server remoto e fai clic su Aggiungi":
      "Enter a name, paste the MCP URL into the remote server URL field, and click Add",
    "⚠️ Disclaimer Legale, Privacy e AI Act":
      "⚠️ Legal, Privacy and AI Act Disclaimer",
    "Protezione dei dati, responsabilità e conformità normativa":
      "Data protection, responsibility and regulatory compliance",
    "L'utilizzo del Snoots Connector for AI implica il trasferimento di dati gestionali verso piattaforme di intelligenza artificiale di terze parti.":
      "Using the Snoots Connector for AI involves transferring management data, including data relating to clients, animal patients and commercial information, to third-party artificial intelligence platforms (Anthropic, OpenAI, Google and other AI providers).",
    "📋 Conformità GDPR (Reg. UE 2016/679)":
      "📋 GDPR Compliance (EU Reg. 2016/679)",
    "L'utente è responsabile di:": "The user is responsible for:",
    "Garantire che il trattamento dei dati tramite piattaforme AI di terze parti sia conforme al GDPR e a qualsiasi altra normativa applicabile in materia di protezione dei dati personali.":
      "Ensuring that data processing through third-party AI platforms complies with EU Regulation 2016/679 (GDPR) and any other applicable personal data protection laws.",
    "Verificare le policy di privacy e i termini di servizio del provider AI prescelto prima di trasferire qualsiasi dato.":
      "Reviewing the privacy policies and terms of service of the chosen AI provider before transferring any data.",
    "Non trasferire dati sensibili di pazienti o clienti verso ambienti AI non conformi alle normative vigenti.":
      "Not transferring sensitive patient or client data to AI environments that do not comply with applicable regulations.",
    "Ottenere, ove necessario, il consenso informato dei propri clienti al trattamento dei loro dati tramite strumenti AI e informarli in modo chiaro di tale utilizzo.":
      "Obtaining, where necessary, informed consent from clients for processing their data through AI tools and clearly informing them of such use.",
    "Proteggere adeguatamente le proprie credenziali di accesso e non condividerle con terze parti.":
      "Adequately protecting access credentials and not sharing them with third parties.",
    "🤖 Conformità AI Act (Reg. UE 2024/1689)":
      "🤖 AI Act Compliance (EU Reg. 2024/1689)",
    "Il Regolamento UE sull'Intelligenza Artificiale introduce ulteriori obblighi per chi utilizza sistemi AI. L'utente è responsabile di:":
      "The EU Artificial Intelligence Regulation (AI Act), in force since August 2024 with progressive application, introduces additional obligations for those who use AI systems. The user is responsible for:",
    "Trasparenza verso i propri clienti: se i dati di clienti o pazienti vengono elaborati tramite sistemi AI, i soggetti interessati devono essere informati in modo chiaro e comprensibile dell'utilizzo di tecnologie di intelligenza artificiale. Non è sufficiente inserire un riferimento nei soli termini e condizioni.":
      "Transparency towards clients (Art. 50, applicable from August 2026): if client or patient data is processed through AI systems, the data subjects must be clearly and understandably informed of the use of artificial intelligence technologies. A reference in the terms and conditions alone is not sufficient.",
    "Supervisione umana: i risultati e le analisi generate dall'AI devono essere sempre rivisti e validati da personale qualificato prima di essere utilizzati per prendere decisioni che incidano su clienti, pazienti o sull'attività clinica. L'AI è uno strumento di supporto, non un sostituto del giudizio professionale.":
      "Human oversight: AI-generated results and analyses must always be reviewed and validated by qualified personnel before being used to make decisions that affect clients, patients or clinical activity. AI is a support tool, not a substitute for professional judgment.",
    "Verifica del provider AI: i modelli AI di uso generale quali Claude, ChatGPT e Gemini sono soggetti agli obblighi previsti dall'AI Act per i loro rispettivi fornitori a partire da agosto 2025. L'utente è tenuto a verificare che il provider AI scelto sia conforme a tali obblighi.":
      "AI provider verification: general-purpose AI models (GPAI) such as Claude, ChatGPT and Gemini are subject to AI Act obligations for their respective providers (Anthropic, OpenAI, Google) from August 2025. The user must verify that the chosen AI provider complies with those obligations.",
    "Alfabetizzazione AI: le organizzazioni che impiegano sistemi AI devono assicurare che il personale coinvolto disponga di un adeguato livello di comprensione delle tecnologie AI utilizzate, dei loro limiti e dei rischi connessi.":
      "AI literacy (Art. 4, applicable from February 2025): organizations using AI systems must ensure that involved personnel have an adequate level of understanding of the AI technologies used, their limitations and related risks.",
    "Classificazione del rischio: il Snoots Connector for AI è un connettore dati per sistemi di gestione veterinaria e non è classificato come sistema AI ad alto rischio ai sensi dell'Allegato III del AI Act. Tuttavia, l'utente rimane responsabile della modalità con cui utilizza i dati e le analisi generate.":
      "Risk classification: the Snoots Connector for AI is a data connector for veterinary management systems and is not classified as a high-risk AI system under Annex III of the AI Act. However, the user remains responsible for how they use the data and generated analyses.",
    "ℹ️ Nota: la normativa AI Act è in fase di applicazione progressiva. Si raccomanda di consultare un consulente legale per una valutazione completa della propria posizione di conformità.":
      "ℹ️ Note: the AI Act is being applied progressively. We recommend consulting a legal advisor for a complete assessment of your compliance position, particularly in relation to obligations that will fully enter into force in August 2026.",
    "Snoots declina ogni responsabilità per eventuali danni, perdite o violazioni derivanti da un utilizzo improprio del plugin, dalla mancata osservanza del GDPR o del AI Act, da decisioni prese sulla base di output AI non validati da personale qualificato, o da configurazioni non sicure da parte dell'utente. Il plugin viene fornito così com'è a titolo gratuito, senza garanzie di alcun tipo.":
      'Snoots disclaims all liability for any damages, losses or violations arising from improper use of the plugin, failure to comply with the GDPR or the AI Act, decisions made based on AI outputs not validated by qualified personnel, or insecure configurations by the user. The plugin is provided "as is" free of charge, without warranties of any kind.',
    "Per informazioni sulla privacy di Snoots:":
      "For information about Snoots privacy:",
    "URL MCP": "MCP URL",
    "API Key": "API Key",
    "Esempio URL completo": "Full URL example",
    "Header da impostare: x-api-key": "Header to set: x-api-key",
    "Intro integrazione MCP":
      "Connect Snoots MCP by copying the URL with the apiKey parameter into supported tools.",
    "Intro metodo header":
      "Use this method if your tool supports setting custom HTTP headers.",
    "Nota metodo header":
      "The API key is sent in the x-api-key header with every request. More secure because the key does not appear in the URL.",
    "Intro metodo query":
      "Use this method if your tool only accepts a URL and does not allow configuring additional headers.",
    "Nota metodo query": "Do not share the URL: it contains the API key.",
    "Hai utilizzato un acconto incassato con un profilo fiscale differente.":
      "You have used a deposit collected with a different tax profile",
    "Performance economica": "Economic performance",
    "Clienti e pazienti": "Customers and patients",
    "Efficienza operativa": "Operational efficiency",
    "Qualità e soddisfazione": "Quality and satisfaction",
    "Ticket medio": "Average ticket",
    "Fatturato medio per contatto": "Average revenue per contact",
    "Fatturato medio per paziente": "Average revenue per patient",
    "Pazienti entrati in clinica": "Patients admitted to clinic",
    "Tasso di crescita contatti": "Contact growth rate",
    "Prestazioni per paziente": "Services per patient",
    "Tempo di attesa medio": "Average waiting time",
    "Tempo di permanenza medio": "Average length of stay",
    "Soddisfazione clienti": "Customer satisfaction",
    "Valore medio delle fatture": "Average invoice value",
    "Importo medio fatturato per contatto": "Average billed amount per contact",
    "Importo medio fatturato da ciascun veterinario":
      "Average billed amount per veterinarian",
    "Importo medio fatturato per ogni paziente":
      "Average billed amount per patient",
    "Numero di pazienti entrati in clinica nel periodo":
      "Number of patients admitted to the clinic during the period",
    "Rapporto tra numero di pretazione e numero di pazienti":
      "Ratio between number of services and number of patients",
    "Media durata in minuti, eccetto i pazienti in degenza":
      "Average duration in minutes, excluding hospitalized patients",
    "Media della soddisfazione cliente nel periodo":
      "Average customer satisfaction during the period",
    "Membro dello staff": "Staff member",
    e: "and",
    giorno: "day",
    giorni: "days",
    mese: "month",
    mesi: "months",
    anno: "year",
    anni: "years",
    "Il paziente ha un acconto non ancora consumato":
      "The patient has an unused advance payment",
    "Abilita per continuare": "Please enable to proceed",
    "Seleziona un provider per compilare i campi":
      "Choose a provider to complete the form",
    "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?":
      "The invoice is not compatible with the chosen flat-rate scheme: some services are not VAT-exempt. Do you wish to proceed anyway?",
    "Non è possibile emettere una fattura senza il nome del cliente":
      "It is not possible to issue an invoice without the customer name",
    "Più opzioni": "More options",
    "È stato trovato un acconto di [remainingAmount] non ancora utilizzato.":
      "An advance payment of {{remainingAmount}} that has not yet been used has been found.",
    "L'acconto presenta i seguenti parziali già assegnati:":
      "The advance payment has the following partial assignments:",
    "L'acconto è già assegnato in una notula:":
      "The advance payment is already assigned in a draft:",
    "Esiste già una notula per questo cliente.":
      "There is already a draft invoice for this customer.",
    "Trovata una notula sul cliente":
      "A draft invoice was found for this customer.",
    "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.":
      "Continue invoicing in the existing draft invoice. Services will be moved to the draft.",
    Apri: "Open",
    "Non mostrare più": "Don’t show again",
    "Crediti per invio email esauriti": "Email sending credits exhausted",
    Autorizzazioni: "Authorizations",
    "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.":
      "Fields marked with • are required for export to Zucchetti or Team System.",
    Gratuito: "Free",
    "Totale insoluto": "Total outstanding",
    "Stampa riepilogo": "Print summary",
    "Visualizza risultato": "View result",
    "Sei sicuro di voler eliminare [count] notule?":
      "Are you sure you want to delete {{count}} draft invoices?",
    "Elimina notule": "Delete draft invoices",
    "Check In rapido": "Quick Check In",
    "Check-in e inizia visita": "Check-in and start visit",
    "Scegliere cosa includere nella stampa:":
      "Choose what to include in the print:",
    "Tutte le voci (fatturate e da fatturare)": "All items (paid and unpaid)",
    "Solo voci da fatturare": "Unpaid items",
    "Solo voci già fatturate": "Paid items",
    "Miglioramenti nella visualizzazione dei turni e reparti in agenda":
      "Improvements in the display of shifts and departments in agenda",
    "Presso altra struttura": "At another structure",
    Specializzazioni: "Specializations",
    "Qualifica e specializzazioni": "Qualification and specializations",
    "Abbiamo tutto ciò che ci serve. Stiamo preparando il tuo spazio di lavoro!":
      "We have everything we need. We're preparing your workspace!",
    "Accetta appuntamenti": "Accepts appointments",
    "Non accetta appuntamenti": "Does not accept appointments",
    "Aggiunta la gestione delle specializzazioni dello staff":
      "Added staff specialization management",
    "Migliorati i filtri dell'agenda per qualifica, reparto e specializzazione":
      "Improved agenda filters by qualification, department and specialization",
    "Migliorata la selezione dello staff nella creazione degli appuntamenti con indicazione di turni e reparti":
      "Improved staff selection when creating appointments with shift and department indicators",
    "I turni possono essere configurati e visualizzati per reparto":
      "Shifts can be configured and displayed by department",
    "Convertito da lead": "Converted from lead",
    "Modifica cliente": "Edit customer",
    "Modifica i dati del cliente.": "Edit the customer data.",
    "Modifica paziente": "Edit patient",
    "Modifica i dati del paziente.": "Edit the patient data.",
    "Modifica impostazioni": "Edit settings",
    "Modifica lingua, zona, studi e backup del tenant.":
      "Edit language, region, studies and tenant backup.",
    "Schede verticali": "Vertical tabs",
    "Schede orizzontali": "Horizontal tabs",
    "Per navigare più facilmente tra le schede, attiva la visualizzazione verticale":
      "To navigate between tabs more easily, enable vertical tabs",
    "Attiva le schede verticali e le azioni compatte: libera spazio su schermi piccoli con schede laterali colorate e barra azioni scorrevole":
      "Enable vertical tabs and compact layout: saves space on small screens with colored side tabs and a scrollable action bar",
    "Attiva le schede verticali e le azioni compatte (solo icone): libera spazio su schermi piccoli e rende ogni scheda riconoscibile dal colore dell'icona":
      "Enable vertical tabs and compact actions (icons only): frees space on small screens and makes each tab recognizable by its icon color",
    "Attiva schede verticali": "Enable vertical tabs",
    "Disattiva schede verticali": "Disable vertical tabs",
    Preferenze: "Preferences",
    Interfaccia: "Interface",
    "Usa schede verticali colorate e azioni compatte nelle pagine di dettaglio con più di due schede.":
      "Use colored vertical tabs and compact actions on detail pages with more than two tabs.",
    "Stai usando la nuova visualizzazione con schede verticali colorate e barra azioni per gruppo":
      "You are using the new layout with colored vertical tabs and color-coded action groups",
    "Attiva le azioni compatte (solo icone): libera spazio e rende ogni gruppo di azioni riconoscibile dal colore":
      "Enable compact actions (icons only): saves space and makes each action group recognizable by color",
    "Stai usando le azioni compatte con icone colorate per gruppo":
      "You are using compact actions with color-coded icons per group",
    "Attiva azioni compatte": "Enable compact actions",
    "Disattiva azioni compatte": "Disable compact actions",
    "Azioni compatte": "Compact actions",
    "Usa azioni compatte (solo icone) con colori per gruppo nella barra azioni delle pagine di dettaglio.":
      "Use compact icon-only actions with color-coded groups in the detail page action bar.",
    "Ripristina versione precedente": "Restore previous version",
    "Rinnovata la gestione degli appuntamenti in agenda con apertura del form nel pannello laterale (Sidespace)":
      "Renewed appointment management in the agenda with the form opening in the side panel (Sidespace)",
    "Aggiunto avviso nel form appuntamento quando data e ora di inizio sono nel passato":
      "Added a warning in the appointment form when the start date and time are in the past",
    "Migliorata la selezione del paziente con etichetta compatta (nome, specie ed età)":
      "Improved patient selection with a compact label (name, species and age)",
    "Migliorata la dashboard statistiche con scrolling virtuale e nuove strutture dati":
      "Improved the analytics dashboard with virtual scrolling and new data structures",
    "Migliorate le anteprime PDF dei documenti con caricamento lazy e cache di sessione":
      "Improved PDF document previews with lazy loading and session cache",
    "Migliorata la selezione degli orari di fine appuntamento con opzioni a step di 15 minuti e indicazione della durata":
      "Improved appointment end time selection with 15-minute step options and duration display",
    "Aggiunto zoom e regolazione larghezza barre nei grafici delle statistiche":
      "Added zoom and bar width controls to analytics charts",
    "Migliorata la validazione delle date in agenda":
      "Improved date validation in the agenda",
    "Migliorata la gestione dell'indirizzo in anagrafica clienti con validazione al cambio":
      "Improved address handling in customer records with validation on change",
    "Aggiunte informazioni tooltip nello scheduler":
      "Added tooltip information in the scheduler",
    "Correzioni minori": "Minor fixes",
    "Le prestazioni nelle notule esistenti verranno unificate in un unica notula. Continuare?":
      "Services in existing draft invoices will be merged into a single draft invoice. Continue?",
    "Modifica modello comunicazione": "Edit communication template",
    "Modifica modello promemoria": "Edit reminder template",
    "Modifica il contenuto del modello usato nelle comunicazioni.":
      "Edit the content of the template used in communications.",
    "Modifica il contenuto del modello usato per i promemoria ai clienti.":
      "Edit the content of the template used for customer reminders.",
    Profis: "Profis",
    "Codice piano dei conti": "Chart of accounts code",
    "Numero attività IVA": "VAT activity number",
    "Numero registro IVA vendite": "Sales VAT register number",
    "Codice IVA — 22%": "VAT code — 22%",
    "Codice IVA — 10%": "VAT code — 10%",
    "Codice IVA — 4%": "VAT code — 4%",
    "Codice IVA — esente": "VAT code — exempt",
    "Causale — fattura vendita / acconto":
      "Transaction type — sales invoice / advance",
    "Causale — nota credito": "Transaction type — credit note",
    "Causale — nota debito": "Transaction type — debit note",
    "Causale — fattura acquisto": "Transaction type — purchase invoice",
    "Causale — incasso / prima nota":
      "Transaction type — collection / journal entry",
    "Conto ausiliario fattura (importo zero)":
      "Auxiliary invoice account (zero amount)",
    "Conto ausiliario incasso": "Auxiliary collection account",
    "Conto chiusura partita incasso": "Collection open-item closing account",
    "Gestione partite clienti": "Customer open items management",
    "Cliente privato (default)": "Private customer (default)",
    Auto: "Auto",
    Sempre: "Always",
    Mai: "Never",
    "Pianificato il": "Scheduled on",
    "Data primo check-in": "First check-in date"
  },
  es: {
    "Non è possibile emettere una fattura senza il nome del cliente":
      "No es posible emitir una factura sin el nombre del cliente"
  },
  fr: {}
};
